import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// In-page anchor links: a #hash change that stays on the same page scrolls to
// its section, smoothly (Bootstrap sets `scroll-behavior: smooth` on :root).
//
// Everything that happens on a route CHANGE now lives in PageTransition: the
// scroll resets to the top while the old page has faded out, and a hash carried
// across pages (/ux-writing#writing-lab) lands on its section instantly once the
// new page mounts. This component used to do both, from an effect that ran after
// the new page had already painted at the old scroll position.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const previousPath = useRef(pathname);

  useEffect(() => {
    const samePage = previousPath.current === pathname;
    previousPath.current = pathname;
    if (!samePage || !hash) return undefined;
    const frame = requestAnimationFrame(() => {
      document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView();
    });
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
